import BaseLink, { LinkProps } from "@mui/material/Link";
import { styled } from "@mui/material/styles";

export const Link = styled(BaseLink)`
  cursor: pointer;
`;

export type { LinkProps };
